import {formatMoney, getDatePrefix} from 'methods/utils';

const primary = {
    getFreeCancellation({date}) {
        return date ? `Бесплатная отмена брони со 100% возвратом предоплаты <span style="font-weight: 500">до ${date}</span>` : '';
    },
    getNoCancellation({date, time}) {
        if (date && time) {
            return time > Date.now()
                ? `Предоплата не возвращается при отмене брони <span style="font-weight: 500">${getDatePrefix(time)} ${date}</span>`
                : 'Предоплата не возвращается';
        }

        return '';
    },
    getNoRefundCancellation({value}) {
        return value === 1 ? 'Задаток не возвращается' : '';
    },
    getPenaltyCancellation({date, price}) {
        return date && price
            ? `После <span style="font-weight: 500;">${date}</span> отмена бронирования без возврата предоплаты в ${formatMoney(price)} ₽`
            : '';
    },
};

const secondary = {
    getFreeCancellation({date}) {
        return date
            ? `Бесплатная отмена бронирования без штрафа <span style="font-weight: 500;">до ${date}</span>`
            : '';
    },
    getNoCancellation({date, time}) {
        if (date && time) {
            return time > Date.now()
                ? `Предоплата не возвращается при отмене брони <span style="font-weight: 500">${getDatePrefix(time)} ${date}</span>`
                : 'Предоплата не возвращается';
        }

        return '';
    },
    getNoRefundCancellation({value}) {
        return value === 1
            ? 'Задаток не возвращается'
            : '';
    },
    getPenaltyCancellation({date, time, price}) {
        return date && time && price
            ? `Отмена бронирования <span style="font-weight: 500;">${getDatePrefix(time)} ${date}</span> со штрафом в ${formatMoney(price)} ₽`
            : '';
    },
};

const short = {
    getFreeCancellation() {
        return 'Бесплатная отмена';
    },
    getNoCancellation() {
        return 'Предоплата невозвратная';
    },
    getNoRefundCancellation() {
        return 'Задаток не возвращается';
    },
    getPenaltyCancellation() {
        return 'Отмена со штрафом';
    },
};

export default function(type = 'primary') {
    if (type === 'short') {
        return short;
    }

    if (type === 'secondary') {
        return secondary;
    }

    return primary;
}
